import { Controller } from '@hotwired/stimulus';

export default class SelfAssessmentTestController extends Controller {
  static values = {
    correctAnswer: String,
    testType:      String
  };

  static targets = [
    'assessButton',
    'nextButton',
    'correctMessage',
    'incorrectMessage',
    'answerTextField'
  ];

  ready(e) {
    this.assessButtonTarget.disabled = false;

    this.answerTextFieldTarget.value = e.detail.answer;
  }

  notReady() {
    this.assessButtonTarget.disabled = true;

    this.answerTextFieldTarget.value = '';
  }

  assess() {
    this.assessButtonTarget.disabled = true;

    if (isCorrect(this.testTypeValue, this.correctAnswerValue, this.answerTextFieldTarget.value)) {
      this.correctMessageTarget.hidden = false;
    } else {
      this.incorrectMessageTarget.hidden = false;
    }

    if (this.hasNextButtonTarget) {
      this.nextButtonTarget.disabled = false;
    }
  }
}

function isCorrect(testType, correct, answer) {
  switch (testType) {
    case 'no_particular_order_test':
      return correct.split('/').sort().join('/') === answer.split('/').sort().join('/');
    case 'description_test':
      return correct.split('/').includes(answer);
    default:
      return correct === answer;
  }
}
